import '@grupoboticario/flora-screenrecording-addon'
import('./bootstrap')
export {}
